import { render, staticRenderFns } from "./indexnew.vue?vue&type=template&id=755fdb48&"
import script from "./indexnew.vue?vue&type=script&lang=js&"
export * from "./indexnew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports